export const LEAVEREQUESTLIST_SEARCH = 'LEAVEREQUESTLIST_SEARCH';
export const LEAVEREQUESTLIST_PAGE = 'LEAVEREQUESTLIST_PAGE';
export const LEAVEREQUESTLIST_STARTDATE = 'LEAVEREQUESTLIST_STARTDATE';
export const LEAVEREQUESTLIST_ENDDATE = 'LEAVEREQUESTLIST_ENDDATE';
export const LEAVEREQUESTLIST_STATUS = 'LEAVEREQUESTLIST_STATUS';
export const LEAVEREQUESTLIST_YEAR = 'LEAVEREQUESTLIST_YEAR';